/**
 * Barrel export del feature `auth`.
 *
 * Objetivo: que el resto de la app consuma el API público desde `@/features/auth`
 * sin importar rutas internas (components/, hooks/, providers/, etc.).
 */

// ===== Server utilities =====
export * from "./cookies";
export * from "./types";
export * from "./actions";

// ===== Providers =====
export * from "./providers/auth-provider";

// ===== Hooks =====
export * from "./hooks/use-session";
export * from "./hooks/use-last-log-in-date";

// ===== Views =====
export * from "./views/login-view-page";
export * from "./views/finish-registration-view-page";
export * from "./views/send-reset-email-view";

// ===== Components =====
export * from "./components/client-auth-guard";
export * from "./components/server-auth-guard";

export * from "./components/login-form";
export * from "./components/logout-form";
export * from "./components/two-factor-code-modal";
export * from "./components/send-reset-mail-password-form";
export * from "./components/reset-password-form";
